export default __webpack_public_path__ + "static/media/program_banner_Hk.52d40723.webp";